



















import { Vue, Prop, Component } from 'vue-property-decorator'
import { parseInt, isEmpty } from 'lodash'
import { toDemotion } from '@core/utils/helper'

@Component
export default class PriceText extends Vue {
  @Prop({ default: 0 }) readonly minPrice!: number
  @Prop({ default: 0 }) readonly maxPrice!: number
  @Prop({ default: 0 }) readonly orginPrice!: number
  @Prop({ default: '' }) readonly priceType!: string /* 默认现金、integral积分、entertainment游乐卡  */
  @Prop({ default: '' }) readonly integral!: string
  @Prop({ default: '' }) readonly entertainment!: string

  integer = ''
  decimal = ''
  isEmpty = isEmpty

  get orgPrice() {
    const p = toDemotion(this.orginPrice)
    return `${p}`
  }

  created() {
    const p = toDemotion(this.minPrice).toString()
    const result = p.split('.')
    if (result.length === 2) {
      this.integer = result[0]
      if (parseInt(result[1]) > 0) {
        this.decimal = result[1]
      }
    } else {
      if (this.minPrice >= 0) {
        this.integer = p
      }
    }
  }
}
